import {messages} from '@smartmixin/i18n';
import {Box, Link} from '@mui/material';
import {useIntl} from 'react-intl';
import {Section} from '../../components/ui';
import {useHelpBasePath} from '../hooks/useHelpLocale';
import {Article} from '../types';

type RelatedArticlesProps = {
  articles: Article[];
};

/** The article's "Related articles": an h2 section with a list of links. */
const RelatedArticles = ({articles}: RelatedArticlesProps) => {
  const {formatMessage} = useIntl();
  const helpBasePath = useHelpBasePath();

  if (articles.length === 0) {
    return null;
  }

  return (
    <Section
      title={formatMessage(messages.helpCenter.relatedArticles)}
      sx={{mt: 4}}>
      <Box component="ul" sx={{m: 0, pl: 2.5}}>
        {articles.map((article) => (
          <Box component="li" key={article.id} sx={{py: 0.5}}>
            <Link
              href={`${helpBasePath}/${article.slug}`}
              sx={{typography: 'body1', color: 'ink.main'}}>
              {article.title}
            </Link>
          </Box>
        ))}
      </Box>
    </Section>
  );
};

export default RelatedArticles;
